import Svg, { type SvgProps } from './Svg';
import type { LogoName } from './types';

export default Svg;
export type { LogoName, SvgProps };
